'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Spotify';

var EntypoSpotify = function EntypoSpotify(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10,1.2c-4.861,0-8.8,3.938-8.8,8.8c0,4.859,3.939,8.8,8.8,8.8c4.862,0,8.799-3.94,8.799-8.8C18.799,5.139,14.863,1.2,10,1.2z M13.478,14.502c-0.173,0-0.294-0.066-0.421-0.143c-1.189-0.721-2.662-1.099-4.258-1.099c-0.814,0-1.693,0.097-2.61,0.285l-0.112,0.028c-0.116,0.028-0.235,0.059-0.326,0.059c-0.371,0-0.661-0.288-0.661-0.656c0-0.373,0.21-0.637,0.562-0.703c1.096-0.25,2.128-0.372,3.152-0.372c1.855,0,3.513,0.43,4.931,1.279c0.243,0.142,0.396,0.306,0.396,0.668C14.13,14.209,13.838,14.502,13.478,14.502z M14.391,11.941c-0.207,0-0.343-0.079-0.463-0.149c-2.143-1.271-5.333-1.693-7.961-0.993c-0.044,0.013-0.084,0.025-0.12,0.037c-0.099,0.031-0.191,0.062-0.321,0.062c-0.432,0-0.783-0.353-0.783-0.788c0-0.419,0.219-0.712,0.614-0.824C6.37,9.008,7.321,8.824,8.69,8.824c2.212,0,4.357,0.555,6.038,1.561c0.306,0.175,0.445,0.414,0.445,0.771C15.173,11.59,14.822,11.941,14.391,11.941z M15.427,9.021c-0.195,0-0.315-0.047-0.495-0.144c-1.453-0.872-3.72-1.391-6.069-1.391c-1.224,0-2.336,0.135-3.306,0.397C5.524,7.891,5.493,7.9,5.459,7.91C5.356,7.941,5.227,7.978,5.094,7.978c-0.516,0-0.919-0.408-0.919-0.929c0-0.453,0.254-0.799,0.68-0.925c1.171-0.346,2.519-0.521,4.006-0.521c2.678,0,5.226,0.595,6.991,1.631c0.332,0.189,0.495,0.475,0.495,0.872C16.347,8.619,15.943,9.021,15.427,9.021z' })
    );
};

exports.default = EntypoSpotify;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-entypo-icons/lib/entypo/Spotify.js
// module id = 7524
// module chunks = 0